import tx from '@/services/apis/tx'
import { CurrentFlowStatResult } from '@/services/apis/tx/models'
import { formatUSD } from '@/utils/format'
import { useEffect, useState } from 'react'
const useFormatedAsset = (walletAssets: CurrentFlowStatResult | null) => {
  const { inflowUsd, outflowUsd, netInflowUsd, inflowNum, outflowNum } = walletAssets ?? {}
  const assets = {
    inflowUsd,
    outflowUsd,
    netInflowUsd,
  }
  type AssetKey = keyof typeof assets
  const fixedAssets = (Object.keys(assets) as AssetKey[]).reduce((accum, key) => {
    const val = assets[key]
    if (val) {
      accum[key] = formatUSD(val)
    }
    return accum
  }, assets)

  return {
    ...fixedAssets,
    inflowNum,
    outflowNum,
  }
}
export const useGetCurrentFlowData = (UTC: number) => {
  const [data, setData] = useState<CurrentFlowStatResult | null>(null)
  const [refreshDep, setRefreshDep] = useState<number>()
  const [isDisable, setIsDisable] = useState(false)
  useEffect(() => {
    setIsDisable(true)
    tx.getCurrentFlowStat(UTC).then(res => {
      setData(res.data)
      setIsDisable(false)
    })
  }, [UTC, refreshDep])
  return {
    ...useFormatedAsset(data),
    setRefreshDep,
    isDisable,
  }
}
